import {useAppDispatch} from "../../../../../../hooks/hooks";
import {useCallback} from "react";
import {ValidateSignupRequestDTO} from "../../../../../../types/signup";
import {verifySignupRequest} from "../../../../../../store/singup/signupSlice";

export function useSignupVerifyActions() {
    const dispatch = useAppDispatch();

    const verifyLogs = useCallback(
        async (dto: ValidateSignupRequestDTO) => {
            const request: ValidateSignupRequestDTO = {
                signupSteps: dto.signupSteps,
                email: dto.email,
                codePhone: dto.codePhone,
                phoneNumber: dto.phoneNumber,
                birthday: dto.birthday,
                name: dto.name,
                gender: dto.gender,
                address: dto.address,
                nationality: dto.nationality,
            };

            try {
                await dispatch(verifySignupRequest(request)).unwrap();
            } catch (error) {
                console.error('Failed to signup:', error);
                throw error;
            }
        },
        [dispatch]
    );

    return{
        verifyLogs
    }
}